const Login = () => {
  return (
    <main>
      <h3>Login</h3>
    </main>
  )
}

export default Login
